import { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import * as auth from './_redux/authRedux'
import * as authCrud from './_redux/authCrud'

const TRUSTED_SSO_ORIGINS = (
	process.env.REACT_APP_SSO_TRUSTED_ORIGINS || 'http://localhost:3001,https://auth.singlelogin.io'
)
	.split(',')
	.map((origin) => origin.trim())
	.filter(Boolean)

export default function SsoListener() {
	const dispatch = useDispatch()
	const handling = useRef(false)

	useEffect(() => {
		const handleMessage = async (event) => {
			if (!TRUSTED_SSO_ORIGINS.includes(event.origin)) return

			const { type, publicKey, privateKey, source } = event.data || {}
			if (type !== 'SSO_LOGIN' || source !== 'sso_redirect') return
			if (!publicKey || !privateKey || handling.current) return

			handling.current = true
			try {
				const response = await authCrud.login_with_keys(publicKey, privateKey)
				if (!response?.auth_token || !response?.refresh_token) {
					throw new Error('Unable to login')
				}
				const user = await authCrud.getUserByToken(response.auth_token)
				dispatch(
					auth.actions.login({
						authToken: response.auth_token,
						refreshToken: response.refresh_token,
						user,
					})
				)
			} catch (error) {
				console.error('SSO login failed', error)
				handling.current = false
			}
		}

		window.addEventListener('message', handleMessage)
		return () => window.removeEventListener('message', handleMessage)
	}, [dispatch])

	return null
}
